export default "__VITE_ASSET__q_3Siwj$__"